import './collapse.scss';

/**
 * Emulate bootstrap collapse without jQuery
 */
let collapseButtons = document.querySelectorAll('[data-toggle="collapse"]');

for (let i = 0, n = collapseButtons.length; i < n; i++) {
    let el = collapseButtons[i];
    let target = document.querySelector(el.dataset.target);
    el.addEventListener('click', function(){
        let expanded = target.classList.contains('expanded');
        if (expanded) {
            target.classList.remove('expanded');
        } else {
            target.classList.add('expanded');
        }
    });
    window.addEventListener('resize', function(){
        target.classList.remove('expanded');
    });
}



// WEBPACK FOOTER //
// ./src/js/collapse/collapse.js